import { Injectable } from '@angular/core';

import { HttpService } from 'tms-lib';
import { TmsWebBaseImportService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ImportCustomerProductService extends TmsWebBaseImportService {
  constructor(protected httpService: HttpService) {
    super('ImportCustomerProduct', 'Customer Products', httpService);
  }
}
